var map = {
	"./BPG.json": "9279",
	"./BTC2Ripple.json": "fa3b",
	"./Bitso.json": "e950",
	"./Bitstamp.json": "a832",
	"./Coinex.json": "fed5",
	"./DigitalGateJapan.json": "d08e",
	"./DividendRippler.json": "030c",
	"./DotPayco.json": "c903",
	"./EXRP.json": "9568",
	"./GBI.json": "d737",
	"./Gatehub.json": "1613",
	"./GatehubFifth.json": "1613",
	"./Justcoin.json": "58c2",
	"./LakeBTC.json": "e609",
	"./Mr.Exchange.json": "9737",
	"./PaxMoneta.json": "329d",
	"./Payroutes.json": "2400",
	"./Rippex.json": "2962",
	"./RippleChina.json": "ab5a",
	"./RippleExchangeTokyo.json": "e6ee",
	"./RippleFox.json": "7cb4",
	"./RippleLatAm.json": "fb2a",
	"./RippleSingapore.json": "6319",
	"./RippleTradeJapan.json": "7575",
	"./RippleUnion.json": "afca",
	"./Ripula.json": "bbf9",
	"./TheRockTrading.json": "374e",
	"./TokyoJPY.json": "43af",
	"./WisePass.json": "1ea1",
	"./rippleCN.json": "bc61",
	"./template.json": "e876"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "95d8";